import React from "react"
import classnames from "classnames"
import PropTypes from "prop-types"

import { translate } from "react-i18next"
import compose from "ramda/src/compose"
import { connect } from "react-redux"

import Typograph from "components/Typograph"

import { logout, saveOperation } from "services/state/actions"

import styles from "./styles.css"

const LogoutButton = ({
  classNames,
  innerClasses,
  icon: Icon = () => null,
  t,
  logout,
  preset = "span",
  atPosition = "end",
  id
}) => {
  const buttonClasses = classnames(
    "u-flex u-flexAlignItemsCenter ",
    { "u-flexJustifyEnd": atPosition === "end" },
    { "u-flexJustifyStart": atPosition === "start" },
    styles.outline,
    classNames
  )

  return (
    <button id={id} className={buttonClasses} onClick={logout}>
      <Icon />
      <Typograph
        classNames={innerClasses}
        htmlTag="span"
        size="small"
        preset={preset}
        color="deep_sea_green"
        weight="bold"
      >
        {t("MSG_0461")}
      </Typograph>
    </button>
  )
}

LogoutButton.propTypes = {
  classNames: PropTypes.string,
  icon: PropTypes.func,
  logout: PropTypes.func,
  t: PropTypes.func,
  preset: PropTypes.string,
  innerClasses: PropTypes.string,
  atPosition: PropTypes.string,
  id: PropTypes.string
}

const enhance = compose(translate(), connect(null, { logout, saveOperation }))

export default enhance(LogoutButton)



// WEBPACK FOOTER //
// ./src/components/LogoutButton/index.js